import { PUBLIC_URL } from "./env";
import { getItem, removeItem, setItem } from "./helpers/localStorage";

// Local storage helpers
export const setRedirect = (path: string, search: string) => {
    setItem("pr_redirect_path", path);
    setItem("pr_redirect_search", search);
};

const clearRedirect = () => {
    removeItem("pr_redirect_path");
    removeItem("pr_redirect_search");
};

const getRedirect = () => {
    const path = getItem("pr_redirect_path");
    const search = getItem("pr_redirect_search");
    return { path, search };
};

/** The url prefix pull request builds are published under. */
const PULL_REQUEST_PREFIX = "/_pr/";

/**
 * Split a `/_pr/<sha>/rest` pathname into the base path the pull request build
 * is published under and the router relative path inside it. Returns undefined
 * for any pathname that does not point into a pull request build.
 */
export const splitPullRequestPath = (pathname: string) => {
    if (!pathname.startsWith(PULL_REQUEST_PREFIX)) {
        return undefined;
    }
    // ["", "_pr", "<sha>", ...rest]
    const parts = pathname.split("/");
    if (!parts[2]) {
        return undefined;
    }
    return {
        basePath: parts.slice(0, 3).join("/"),
        path: `/${parts.slice(3).join("/")}`,
    };
};

/**
 * The pending redirect path without consuming it. Bootstrap needs the account id
 * of the page we are on our way to before RedirectToAccount clears the redirect.
 */
export const peekPullRequestRedirectPath = () =>
    getItem("pr_redirect_path") || undefined;

// Get next location for PR builds. Kept out of RedirectToPullRequestRoute.tsx
// so consumers (RedirectToAccount) can call it synchronously without pulling
// the lazy-loaded route component into the main bundle.
export const getAndClearPullRequestRedirect = () => {
    const routerBaseName = PUBLIC_URL || "/";
    const pullRequestBaseName = routerBaseName !== "/";
    const { path, search } = getRedirect();
    // Clear redirect regardless of whether we are on a PR build or not
    clearRedirect();
    if (pullRequestBaseName && path) {
        return path + search;
    }
};
